var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 500 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    stroke: "#000",
    transform: "translate(0 -52.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect1872",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    rx: 50,
    ry: 50,
    height: 972.48,
    width: 472.48,
    y: 66.121,
    x: 13.759,
    strokeWidth: 27.517,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15666",
    strokeWidth: "10px",
    fill: "none",
    d: "m45 552.36h410"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(0 -52.362)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle10",
    cy: 456,
    cx: 110,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle12",
    cy: 312,
    cx: 110,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle14",
    cy: 168,
    cx: 110,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle16",
    cy: 456,
    cx: 390,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle18",
    cy: 312,
    cx: 390,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle20",
    cy: 168,
    cx: 390,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle22",
    cy: 936,
    cx: 110,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle24",
    cy: 792,
    cx: 110,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle26",
    cy: 648,
    cx: 110,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle28",
    cy: 936,
    cx: 390,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle30",
    cy: 792,
    cx: 390,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle32",
    cy: 648,
    cx: 390,
    r: 50
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomino);
export default __webpack_public_path__ + "static/media/domino.479dc423.svg";
export { ForwardRef as ReactComponent };